/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as React from 'react';

export interface ICreateAsynchronousPaymentErrorTitleProps {
    title?: string;
}

/**
 * AddPaymentForm SFC.
 * @param root0
 * @param root0.title
 * @extends {React.FC<ICreateAsynchronousPaymentErrorTitleProps>}
 */
const CreateAsynchronousPaymentErrorTitle: React.FC<ICreateAsynchronousPaymentErrorTitleProps> = ({ title }) => {
    if (!title) {
        return null;
    }

    return <p className='ms-create-asynchronous-payment__error-title'>{title}</p>;
};

export default CreateAsynchronousPaymentErrorTitle;
